import type { TaskIngredientView } from '@nexelem/graphne-api';
import { useCustomTranslation } from '../../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faCube } from '@fortawesome/pro-light-svg-icons';
import { createColumnHelper } from '@nexelem/tanstack-table';
import { useMemo } from 'react';
import { IconButton, Popover } from '@nexelem/components';

const columnHelper = createColumnHelper<TaskIngredientView>();

export const useColumns = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.billOfMaterial');

  const columns = useMemo(
    () => [
      columnHelper.accessor('tpe', {
        id: 'missing_stock',
        header: '',
        enableSorting: false,
        enableResizing: false,
        size: 48,
        cell: ({ getValue }) =>
          getValue() === 'Missing' ? (
            <FontAwesomeIcon className="size-5! text-text-status-yellow-darker" icon={faCube} />
          ) : null,
      }),
      columnHelper.display({
        id: 'product_name',
        header: tWrapper('product'),
        enableSorting: false,
        size: 450,
        cell: ({ row }) => (
          <div className="flex flex-col">
            <span className="text-s11-sb text-text-secondary-darker uppercase">{row.original.itemTypeVariantName}</span>
            <span className="text-s16">{row.original.itemTypeExternalId}</span>
          </div>
        ),
      }),
      columnHelper.accessor('requiredAmount', {
        header: tWrapper('quantityPerLot'),
        size: 250,
        enableSorting: false,
        meta: {
          textAlign: 'right',
        },
      }),
      columnHelper.accessor('missingAmount', {
        header: () => (
          <div className="flex items-center gap-1">
            {tWrapper('missingAmount')}
            <Popover.Root>
              <Popover.Trigger>
                <IconButton Icon={<FontAwesomeIcon icon={faCircleQuestion} />} />
              </Popover.Trigger>
              <Popover.Content>{tWrapper('missingAmountInfo')}</Popover.Content>
            </Popover.Root>
          </div>
        ),
        enableSorting: false,
        size: 300,
        meta: {
          textAlign: 'right',
        },
      }),
      columnHelper.accessor('unitType', {
        header: tWrapper('unit'),
        size: 150,
        enableSorting: false,
      }),
    ],
    [tWrapper],
  );

  return { columns };
};
